import { useSendAnalyticsEvent } from './analytics';
import { useDataContext } from 'src/contexts';
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';

const createAndClickLink = (blobUrl: string, name: string) => {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = name;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const postHogEventName = 'pvo_media_download';

export const useDownloadMedia = () => {
  const { sendEvent } = useSendAnalyticsEvent();
  const setIsLoading = useDataContext((ctx) => ctx.setIsLoading);
  const pvoData = useDataContext((ctx) => ctx.pvoData);

  const handleSendEvent = () => {
    sendEvent(postHogEventName);
  };

  const download = async () => {
    setIsLoading(true);

    try {
      const file = pvoData.files?.[0];
      if (!file?.blobFile) {
        return;
      }

      const fileName = file.blobFile.name;
      const blobUrl = URL.createObjectURL(file.blobFile);
      createAndClickLink(blobUrl, fileName);
      URL.revokeObjectURL(blobUrl);

      handleSendEvent();
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') {
        return;
      }

      Sentry.captureException(error, {
        extra: {
          eventName: postHogEventName,
          userAgent: navigator.userAgent,
        },
      });
      toast.error('An error occurred while downloading files.');
    } finally {
      await delay(500);
      setIsLoading(false);
    }
  };

  return { download };
};
